import { render, staticRenderFns } from "./QuotationStatusMessage.vue?vue&type=template&id=fd39659e"
import script from "./QuotationStatusMessage.vue?vue&type=script&lang=js"
export * from "./QuotationStatusMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports